<template>
  <v-layout row wrap style="height: 100%">
    <v-flex xs12>
      <ul style="list-style-type: circle;">
        <li v-for="event in dayOfWeekTimesChangeList">
          <span>
            <b>{{event.field}}</b> changed from
            <b>{{ event.old_value }}</b>&nbsp;to
            <b>{{ event.new_value }}</b>
          </span>
        </li>
        <li v-for="event in changeList">
          <span>
            {{event.field}} changed from
            <b>{{ event.old_value }}</b>&nbsp;to
            <b>{{ event.new_value }}</b>
          </span>
        </li>
      </ul>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "TripChanges",
  model: {
    prop: "content",
    event: "input"
  },
  components: {},
  props: {
    oldTripDefinition: Object,
    newTripDefinition: Object
  },
  computed: {
    dayOfWeekTimesChangeList: function() {
      var aTime = this.oldTripDefinition.day_of_week_times_list;
      var bTime = this.newTripDefinition.day_of_week_times_list;

      var changes = [];

      for (var i = 0; i < aTime.length; i++) {
        console.log(aTime[i].time + " " + bTime[i].time);

        if (aTime[i].time == "") {
          aTime[i].time = null;
        }

        if (bTime[i].time == "") {
          bTime[i].time = null;
        }

        if (aTime[i].time != bTime[i].time) {
          changes.push({
            field: aTime[i].day_of_week,
            old_value: aTime[i].time,
            new_value: bTime[i].time
          });
        }
      }

      return changes;
    },
    changeList: function() {
      var a = this.oldTripDefinition.repeat_trip_template.booking;
      var b = this.newTripDefinition.repeat_trip_template.booking;

      var changes = [];

      this.compareOldNewValues(changes, "Notes", a.notes, b.notes);
      this.compareOldNewValues(changes, "Message", a.message, b.message);

      this.compareOldNewValues(
        changes,
        "Business Customer Name",
        a.business_customer_name,
        b.business_customer_name
      );
      this.compareOldNewValues(
        changes,
        "Business Customer Email",
        a.business_customer_email,
        b.business_customer_email
      );
      this.compareOldNewValues(
        changes,
        "Business Customer Number",
        a.business_customer_number,
        b.business_customer_number
      );
      this.compareOldNewValues(
        changes,
        "Business Reference Number",
        a.business_customer_reference,
        b.business_customer_reference
      );

      this.compareOldNewValues(
        changes,
        "Number of People",
        a.num_people,
        b.num_people
      );
      this.compareOldNewValues(
        changes,
        "Disabled Access",
        a.needs_disabled_access,
        b.needs_disabled_access
      );
      this.compareOldNewValues(
        changes,
        "Premium Vehicle",
        a.premium,
        b.premium
      );
      this.compareOldNewValues(changes, "Pets", a.needs_pets, b.needs_pets);
      this.compareOldNewValues(changes, "Luggage", a.luggage, b.luggage);
      this.compareOldNewValues(
        changes,
        "Meet & Greet",
        a.meet_and_greet,
        b.meet_and_greet
      );

      this.compareOldNewValues(
        changes,
        "Payment Type",
        a.payment_type,
        b.payment_type
      );

      this.compareOldNewValues(changes, "Card", a.card, b.card);

      this.compareOldNewValues(
        changes,
        " Final Cost",
        a.final_cost,
        b.final_cost
      );
      this.compareOldNewValues(
        changes,
        "Final Cost Driver",
        a.final_cost_driver,
        b.final_cost_driver
      );

      this.compareOldNewValues(changes, "Ride Type", a.ride_type, b.ride_type);

      this.compareOldNewValues(
        changes,
        "Manual Dispatch",
        a.manual_dispatch,
        b.manual_dispatch
      );

      this.compareOldNewValues(
        changes,
        "Preassigned Driver",
        JSON.stringify(a.preassigned_driver),
        JSON.stringify(b.preassigned_driver)
      );

      this.compareOldNewValues(
        changes,
        "Pickup Location",
        a.pickup_location.description,
        b.pickup_location.description
      );

      var oldValue = "";
      a.destinations.forEach(function(dest) {
        if (dest.description != null) {
          oldValue += " • " + dest.description;
        }
      });

      var newValue = "";
      b.destinations.forEach(function(dest) {
        if (dest.description != null) {
          newValue += " • " + dest.description;
        }
      });

      if (oldValue != newValue) {
        changes.push({
          field: "Destinations",
          old_value: oldValue,
          new_value: newValue
        });
      }

      this.compareOldNewValues(
        changes,
        "Pickup Passenger Information",
        this.viaInfoToString(a.pickup_info),
        this.viaInfoToString(b.pickup_info)
      );

      this.compareOldNewValues(
        changes,
        "Destination Passenger Information",
        this.viaInfoToString(a.destination_info),
        this.viaInfoToString(b.destination_info)
      );

      oldValue = "";
      a.via_info.forEach(function(via_info) {
        if (via_info != null && via_info.active) {
          console.log(via_info);
          var viaInfoStr = " • ";

          if (via_info.name != "") {
            viaInfoStr += via_info.name + ", ";
          }

          if (via_info.contact_number != "") {
            viaInfoStr += via_info.contact_number + ", ";
          }

          if (via_info.notes != "") {
            viaInfoStr += via_info.notes + ", ";
          }

          oldValue += viaInfoStr;
        }
      });

      newValue = "";
      b.via_info.forEach(function(via_info) {
        if (via_info != null && via_info.active) {
          console.log(via_info);
          var viaInfoStr = " • ";

          if (via_info.name != "") {
            viaInfoStr += via_info.name + ", ";
          }

          if (via_info.contact_number != "") {
            viaInfoStr += via_info.contact_number + ", ";
          }

          if (via_info.notes != "") {
            viaInfoStr += via_info.notes + ", ";
          }

          newValue += viaInfoStr;
        }
      });

      console.log(oldValue);
      console.log(newValue);

      if (oldValue != newValue) {
        changes.push({
          field: "Via Passenger Info",
          old_value: oldValue,
          new_value: newValue
        });
      }

      return changes;
    }
  },
  methods: {
    viaInfoToString: function(via_info) {
      var viaInfoStr = " • ";

      if (via_info.name != "") {
        viaInfoStr += via_info.name + ", ";
      }

      if (via_info.contact_number != "") {
        viaInfoStr += via_info.contact_number + ", ";
      }

      if (via_info.notes != "") {
        viaInfoStr += via_info.notes + ", ";
      }

      return viaInfoStr;
    },
    compareOldNewValues: function(changes, name, oldValue, newValue) {
      if (oldValue != newValue) {
        changes.push({
          field: name,
          old_value: oldValue,
          new_value: newValue
        });
      }
    }
  },
  mounted: function() {},
  data() {
    return {
      tab: null,
      expand: false
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
